<template>
	<b-overlay :show="loading" rounded="lg" spinner-variant="customer">
	</b-overlay>
</template>
<script>
export	default	{
	name:	"home",
	components:	{},
	data()	{
		return	{
			loading: true
		};
	},
	beforeMount(){
		console.log('a')
	},
	mounted(){
		this.validate()
	},
	methods: {
		validate(){
			console.log("Validate")
			if(this.$auth.check()){
				//this.$router.push({ name: "index"});
				this.$auth.user(this.$auth.watch.data);
				window.location.href = 'https://'+window.location.hostname+'/#/';
			}else{
				this.axios.get("auth/validate_token", {headers: {"access-token": this.$route.query['access-token'], "client": this.$route.query['client'], "uid": this.$route.query['uid']}}).then(result => {
					this.$auth.user(result.data.data);
					console.log(this.$auth);
					window.location.href = 'https://'+window.location.hostname;
					//this.$router.push({ name: "index"});
				})
			}
		}
	}
};
</script>
<style>
	.container-login {
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.content-login {
		width: auto;
		height: auto;
	}
	.content-login .btn {
		width: 100%;
	}
	.login-text{
		text-transform: uppercase;
	}
	.login-logo {
		top: 1.6em;
		width: 10em;
	}
	.text-white {
		color: white !important;
	}
</style>